let swiperInstance;

function initializeSwiper() {
  swiperInstance = new Swiper(".lp-ugc__swiper", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    pagination: {
      el: ".ugc-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".ugc-next",
      prevEl: ".ugc-prev",
    },
  });
}

function destroySwiper() {
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }
}

function handleResize() {
  if (window.innerWidth < 768) {
    if (!swiperInstance) {
      initializeSwiper();
    }
  } else {
    destroySwiper();
  }
}

window.addEventListener("resize", handleResize);

handleResize();
